import request from './request';

export async function reportSipReady({ reportUrl, username, sipDomain, reportNonce }) {
  const d = await request.post(reportUrl, {
    reportUrl, username, reportNonce, sipDomain
  });
  return d;
}
